export default "/_next/static/5864beae20be6c5b56b0ea765a3e9c9f.png";